// Creator web visibility (docs/creator-web-visibility.md): the mark lives in the
// user's additionalInfo bag, which the API serves either as a JSON object or as
// a JSON-encoded string.
//
// Deliberately mirrors `isWebPrivate` in the server's utils/webVisibility.js: CRA's
// module scope keeps src/ from importing outside itself, so the two copies must
// agree by hand. Both answer false for anything but an object bag whose
// web.private is exactly true.
export function isWebPrivate(additionalInfo) {
  if (!additionalInfo) return false;
  try {
    const bag = typeof additionalInfo === "string" ? JSON.parse(additionalInfo) : additionalInfo;
    return bag?.web?.private === true;
  } catch {
    return false;
  }
}
